import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for ClashesPane component
 * Provides sidebar, container, and panel layout styling
 */
export const useClashesPaneStyles = makeStyles((theme: Theme) => ({
    sidebar: {
        paddingTop: 20,
        backgroundColor: '#EDF0F6',
        transition: 'width 0.1s cubic-bezier(0.4, 0, 1, 1), opacity 0.3s ease-in-out',
        opacity: 0,
        visibility: 'hidden',
        width: 0,
        display: 'none',
    },
    sidebarOpen: {
        width: '100%',
        opacity: 1,
        visibility: 'visible',
        display: 'block',
    },
    sidebarClosed: {
        width: 0,
        opacity: 0,
        visibility: 'hidden',
        display: 'none',
    },
    clashPanelContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        minWidth: 240,
        width: '100%',
        position: 'relative',
    },
    clashListWrapper: {
        paddingRight: theme.spacing(2.5),
        height: pxToRem(680),
        overflowY: 'auto',
    },
}))
